import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";

export default function SelectPair({
  label,
  value,
  options,
  edit,
  link,
  classes,
  inputOptions,
  loading,
}) {
  const { navigate } = useContext(UtilityContext);

  if (!inputOptions) inputOptions = { id: label.toLowerCase() };
  else if (!inputOptions?.id && !inputOptions?.name)
    inputOptions.id = label.toLowerCase();
  else if (!inputOptions?.name) inputOptions.name = inputOptions.id;
  else if (!inputOptions?.id) inputOptions.id = inputOptions.name;

  const clickHandler = (e) => {
    if (link && !edit) navigate(link, e);
  };
  const classNames = () => {
    if (link) return "cursor-pointer hover:opacity-70";
    else return "";
  };

  if (loading)
    return (
      <div className="grid w-3/4 gap-1">
        <div className="w-1/3 h-4 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-600"></div>
      </div>
    );

  return (
    <div onClick={(e) => clickHandler(e)} className={classNames()}>
      <p className="text-stone-400">{label}:</p>
      {!edit && <p className={classes || "text-stone-200"}>{value || "-"}</p>}
      {edit && (
        <select
          className="w-full h-10 form-input"
          defaultValue={value || options[0]}
          {...inputOptions}
        >
          {options.map((option, idx) => (
            <option
              key={idx}
              value={typeof option === "object" ? option.id : option}
            >
              {typeof option === "object" ? option.name : option}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
